<template>
  <svg
    id="Ebene_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="35px"
    height="35px"
    viewBox="0 0 35 35"
    enable-background="new 0 0 35 35"
    xml:space="preserve"
  >
    <path
      fill="currentColor"
      d="M11.159,33.806c-9.006-3.503-13.466-13.64-9.966-22.648C4.696,2.153,14.837-2.31,23.841,1.196
  	c9.006,3.498,13.466,13.642,9.966,22.645C30.304,32.848,20.163,37.307,11.159,33.806"
    />
    <g>
      <rect x="5.061" y="13.271" fill="#FFFFFF" width="8.459" height="8.459" />
      <rect x="20.55" y="5.717" fill="#FFFFFF" width="6" height="6" />
      <rect x="20.55" y="22.901" fill="#FFFFFF" width="6" height="6" />
      <polyline
        fill="none"
        stroke="#FFFFFF"
        stroke-width="0.9583"
        stroke-miterlimit="10"
        points="9.29,13.271 9.29,8.717 20.55,8.717 
  			"
      />
      <polyline
        fill="none"
        stroke="#FFFFFF"
        stroke-width="0.9583"
        stroke-miterlimit="10"
        points="9.29,21.347 9.29,25.901 
  		20.55,25.901 	"
      />
    </g>
  </svg>
</template>
